module.exports = __webpack_public_path__ + "static/how-it-works-2-63d3c541c406ef1b37d875e7bd67f5d7.png";